
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Patientforcedairpune() {



  const cardData =
  {
    keyword: 'Patient Forced Air Warming System in Pune',
    heading: 'Pharmacle Health Care Private Limited: Patient Forced Air Warming System in Pune',
    headingDescription: 'Pharmacle Health Care Private Limited offers the Patient Forced Air Warming System in Pune, ensuring optimal temperature management during medical procedures. Our Wallabies Warm Care systems are designed to provide efficient and uniform warming, reducing the risk of hypothermia in patients. Trusted by hospitals and healthcare facilities, our forced air warming systems deliver reliability, comfort, and safety. With advanced technology, high-quality materials, and user-friendly operation, we help enhance patient care. Choose Pharmacle Health Care for the best forced air warming solutions in Pune.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',

    "topPlaces": [
      {
        "title": "Patient Forced Air Warming System",
        "description": "Wallabies Warm Care offers state-of-the-art Patient Forced Air Warming Systems in Pune, designed to maintain normothermia during surgical procedures. Our advanced systems ensure precise temperature control, reducing the risk of hypothermia in patients. These systems are widely used in hospitals, surgical centers, and ICUs to enhance patient comfort and recovery."
      },
      {
        "title": "Surgical Forced Air Warming Unit",
        "description": "Our Surgical Forced Air Warming Units are designed to provide consistent and safe temperature management in operating rooms. These units are equipped with advanced sensors and adjustable airflow, ensuring optimal warmth for patients undergoing surgery. Wallabies Warm Care prioritizes patient safety with high-quality, reliable solutions."
      },
      {
        "title": "Portable Patient Warming Systems",
        "description": "For emergency and on-the-go medical applications, our Portable Patient Warming Systems offer a lightweight and efficient solution. These compact units are easy to use and transport, making them ideal for ambulances, critical care transport, and post-operative recovery units."
      },
      {
        "title": "ICU Patient Warming Devices",
        "description": "Wallabies Warm Care provides ICU Patient Warming Devices that help stabilize body temperature for critically ill patients. Our systems ensure uniform heat distribution, preventing complications related to hypothermia. Trusted by medical professionals, these warming devices contribute to improved patient outcomes."
      },
      {
        "title": "Pediatric Forced Air Warming Blankets",
        "description": "Specially designed for pediatric patients, our Forced Air Warming Blankets offer gentle and effective warming. Made from soft, hypoallergenic materials, these blankets ensure maximum comfort and warmth for newborns and children undergoing medical treatments."
      },
      {
        "title": "Disposable Forced Air Warming Blankets",
        "description": "Our Disposable Forced Air Warming Blankets provide a hygienic and effective way to maintain patient body temperature during surgery or recovery. Designed for single-use applications, they help prevent cross-contamination and ensure optimal thermal care in medical environments."
      },
      {
        "title": "Preoperative Patient Warming Solutions",
        "description": "Wallabies Warm Care offers preoperative patient warming solutions to enhance surgical outcomes by preventing perioperative hypothermia. These systems help maintain core body temperature, reducing post-surgical complications and improving patient comfort."
      },
      {
        "title": "Veterinary Forced Air Warming Systems",
        "description": "Our advanced Veterinary Forced Air Warming Systems are specifically designed for animal surgeries and treatments. These systems provide safe, regulated warmth to ensure the well-being of pets and livestock during medical procedures."
      },
      {
        "title": "Advanced Temperature Management Systems",
        "description": "Wallabies Warm Care brings cutting-edge Advanced Temperature Management Systems for hospitals and clinics. These systems offer precise temperature regulation, ensuring the best thermal care for patients in various medical settings."
      },
      {
        "title": "Emergency Patient Warming Devices",
        "description": "Designed for use in trauma centers and emergency response units, our Emergency Patient Warming Devices provide rapid warmth to patients suffering from hypothermia or shock. These devices are a crucial addition to any medical facility focused on emergency care."
      }
    ],


  "services": [
    {
        "name": "Patient Forced Air Warming System Pune",
        "description": "Pharmacle Health Care Private Limited offers advanced patient forced air warming systems in Pune. Our systems ensure optimal body temperature during surgeries and medical procedures, preventing hypothermia and ensuring patient comfort and safety."
    },
    {
        "name": "Pune Patient Forced Air Warming Devices",
        "description": "We provide high-quality patient forced air warming devices in Pune, designed to deliver consistent and effective temperature control. Ideal for surgical and critical care settings, ensuring a safe and comfortable environment for patients."
    },
    {
        "name": "Pune Patient Warming System",
        "description": "Our patient warming systems in Pune are engineered to precisely control and maintain patient body temperature, preventing hypothermia during medical treatments and improving patient recovery post-surgery."
    },
    {
        "name": "Pune Patient Thermoregulation Equipment",
        "description": "Pharmacle Health Care Private Limited offers patient thermoregulation equipment in Pune, ensuring efficient body temperature management. Our equipment is essential for preventing complications during surgery and enhancing patient care."
    },
    {
        "name": "Pune Forced Air Warming Blanket",
        "description": "Our forced air warming blankets in Pune provide an effective and comfortable solution for patient temperature management. Designed for use with our warming systems, these blankets ensure a steady supply of warm air for the patient’s comfort."
    },
    {
        "name": "Pune Medical Warming System",
        "description": "Pharmacle Health Care Private Limited provides advanced medical warming systems in Pune, helping healthcare professionals maintain a controlled temperature for patients during surgeries, critical care, and post-operative care."
    },
    {
        "name": "Pune Forced Air Warming System Supplier",
        "description": "We are a leading supplier of forced air warming systems in Pune. Our products are engineered to deliver precision and reliability, ensuring effective thermoregulation for patients during medical procedures."
    },
    {
        "name": "Pune Patient Warming Solutions",
        "description": "Looking for patient warming solutions in Pune? Pharmacle Health Care Private Limited offers comprehensive warming solutions that ensure safe, effective, and comfortable patient care throughout medical treatments and surgeries."
    },
    {
        "name": "Pune Medical Temperature Control Devices",
        "description": "Our medical temperature control devices in Pune provide precise and reliable management of patient body temperature. Essential in critical care environments, these devices help prevent complications like hypothermia during procedures."
    },
    {
        "name": "Pune Warming Equipment for Hospitals",
        "description": "We supply warming equipment for hospitals in Pune, designed to ensure patient safety and comfort. Our equipment is ideal for use in surgeries, emergency rooms, and post-operative care, maintaining optimal body temperature throughout."
    },
    {
        "name": "Pune Surgical Warming Systems",
        "description": "Our surgical warming systems in Pune are designed to prevent intraoperative hypothermia. These systems provide controlled warmth during surgeries, ensuring patient safety and improving recovery times."
    }
],
"tableData": [
    ["- Patient Forced Air Warming System Pune", "- Pune Patient Forced Air Warming Devices"],
    ["- Pune Patient Warming System", "- Pune Patient Thermoregulation Equipment"],
    ["- Pune Forced Air Warming Blanket", "- Pune Medical Warming System"],
    ["- Pune Forced Air Warming System Supplier", "- Pune Patient Warming Solutions"],
    ["- Pune Medical Temperature Control Devices", "- Pune Warming Equipment for Hospitals"],
    ["- Pune Surgical Warming Systems"]
],

  "whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "Pharmacle Health Care Private Limited offers advanced forced air warming systems and blankets, designed to ensure precise temperature control during medical treatments. Our technology provides reliable performance to prevent hypothermia and improve patient safety in hospitals and clinics."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We provide a wide range of patient warming solutions, including forced air warming devices, blankets, and temperature control systems. Our solutions are tailored to meet the needs of both surgical procedures and critical care, ensuring that your patients remain comfortable and safe."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "All our patient warming equipment is manufactured to the highest quality standards, ensuring durability and long-lasting performance. Regularly serviced and rigorously tested, our products offer optimal reliability for continuous use in medical environments."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient comfort and safety are our top priorities. Our forced air warming blankets and devices deliver controlled, gentle warmth, preventing temperature-related complications during surgeries and procedures, ensuring patients are always in the safest hands."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our patient warming systems offer flexible configurations that are compatible with various healthcare settings, including hospitals, clinics, and emergency rooms. We work closely with healthcare providers to ensure our systems meet their specific needs."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Pharmacle Health Care's patient warming solutions are designed for easy integration with existing medical systems. Our products can be quickly implemented without disrupting ongoing medical procedures, ensuring a smooth and efficient experience for healthcare professionals."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "Our team provides expert consultation to help you choose the right warming solutions for your healthcare facility. We offer ongoing support and maintenance services to ensure that your equipment functions at peak performance, providing peace of mind for medical staff and patients alike."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, patient safety and comfort are at the core of everything we do. Our warming systems are designed to prevent temperature-related issues during critical medical procedures, ensuring that each patient is cared for with the highest standards of safety and comfort."
    }
]





  }




  const faqData = [
    { question: "What is the Patient Forced Air Warming System?", answer: "Our Patient Forced Air Warming System is designed to provide effective and reliable warming to patients during medical procedures, ensuring their comfort and safety." },
    { question: "How does the Patient Forced Air Warming System work?", answer: "The system works by circulating warm air through a specially designed blanket, maintaining the patient's body temperature during surgeries and treatments." },
    { question: "Is the Patient Forced Air Warming System available in Pune?", answer: "Yes, we offer the Patient Forced Air Warming System in Pune, ensuring healthcare facilities have access to quality warming solutions." },
    { question: "What are the benefits of using the Patient Forced Air Warming System?", answer: "The system helps maintain normothermia, prevents surgical site infections, reduces recovery time, and enhances patient comfort during procedures." },
    { question: "How long does the system keep a patient warm?", answer: "The Patient Forced Air Warming System can keep a patient warm for the duration of the medical procedure, depending on the settings and environment." },
    { question: "Is the Patient Forced Air Warming System easy to use?", answer: "Yes, the system is designed for ease of use with intuitive controls, making it simple for healthcare professionals to operate during procedures." },
    { question: "Can the warming blankets be reused?", answer: "Yes, the warming blankets are designed for multiple uses, but they must be cleaned according to the manufacturer's guidelines to ensure proper hygiene." },
    { question: "Is the Patient Forced Air Warming System safe for all patients?", answer: "Yes, the system is safe for most patients, including those with sensitive skin or allergies, but it should always be used according to medical guidelines and under the supervision of healthcare professionals." },
    { question: "Does Pharmacle Health Care offer maintenance for the Patient Forced Air Warming System?", answer: "Yes, we provide regular maintenance and servicing options to ensure the continued reliability and performance of the Patient Forced Air Warming System." },
    { question: "How can I purchase the Patient Forced Air Warming System?", answer: "You can contact our sales team at Pharmacle Health Care Private Limited, and we will guide you through the purchasing process and provide all necessary information." }
  ];
  
  const testimonialsData = [
    {
      text: 'We used the Patient Forced Air Warming System from Wallabies Warm Care in our hospital in Pune. The system has improved patient comfort and helped in preventing hypothermia during surgeries.',
      name: 'Dr. Neha Sharma',
    },
    {
      text: 'The Patient Forced Air Warming System by Wallabies Warm Care has made a significant difference in our clinic. The product is easy to use and highly effective.',
      name: 'Dr. Ramesh Iyer',
    }
  ];
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];

  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Patient Forced Air Warming System in Pune",
    "description": "Explore high-quality Patient Forced Air Warming Systems in Pune. We provide advanced medical temperature control solutions for hospitals, clinics, and surgical settings. Our systems ensure effective patient thermoregulation during surgeries and treatments.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.8",
      "ratingCount": "1475"
    }
  };
  



  return (
    <div>

<Helmet>
  <title>Patient Forced Air Warming System in Pune | Contact: +91 8956322311</title>
  <meta
    name="description"
    content="Explore high-quality Patient Forced Air Warming Systems in Pune for effective patient thermoregulation during surgeries and treatments. Contact us at +91 8956322311."
  />
  <meta
    name="keywords"
    content="Patient Forced Air Warming System Pune, Pune Patient Forced Air Warming Devices, Pune Patient Warming System, Pune Patient Thermoregulation Equipment, Pune Forced Air Warming Blanket, Pune Medical Warming System, Pune Forced Air Warming System Supplier, Pune Patient Warming Solutions, Pune Medical Temperature Control Devices, Pune Warming Equipment for Hospitals, Pune Surgical Warming Systems"
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/1.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Navar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Patientforcedairpune;